import { useMutation } from "react-query";
import {
  RelatorioComposicaoContasPdfResponse,
  RelatorioComposicaoContasQueryParams,
} from "../typings";
import { AxiosError } from "axios";
import http from "infra/http";
import { OperacaoEnum } from "resources/enums/conta";

function useRelatorioComposicaoContasPdf(
  query: RelatorioComposicaoContasQueryParams,
  operacao: OperacaoEnum
) {
  return useMutation<RelatorioComposicaoContasPdfResponse, AxiosError>(
    [`/v1/relatorios/financeiro/composicao-contas/pdf`, query, operacao],
    async () => {
      const { data } = await http.get<RelatorioComposicaoContasPdfResponse>(
        operacao === OperacaoEnum.Despesa
          ? "/v1/relatorios/financeiro/composicao-despesas/pdf"
          : "/v1/relatorios/financeiro/composicao-receitas/pdf",
        {
          params: query,
        }
      );

      return data;
    }
  );
}

export default useRelatorioComposicaoContasPdf;
